import { useLocation } from "react-router-dom";

const SITE = "https://olawventures.co.uk";

export const Seo = ({ title, description, jsonLd }) => {
  const { pathname } = useLocation();
  const canonical = `${SITE}${pathname === "/" ? "" : pathname}`;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="O Law Ventures Ltd" />
      <meta name="twitter:card" content="summary_large_image" />
      {blocks.map((block) => (
        <script
          key={block["@type"] || block.name}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(block).replace(/</g, "\\u003c") }}
        />
      ))}
    </>
  );
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "O Law Ventures Ltd",
  description:
    "UK housing standards compliance specialists providing expert HHSRS hazard reports, compliance advisory and training for landlords, managing agents and private tenants.",
  url: SITE,
  email: "enquiries@olawventures.com",
  telephone: "+447949300473",
  areaServed: "GB",
  priceRange: "££",
  address: {
    "@type": "PostalAddress",
    streetAddress: "128 City Road",
    addressLocality: "London",
    postalCode: "EC1V 2NX",
    addressCountry: "GB",
  },
  sameAs: ["https://www.linkedin.com/in/osahon-l-67306559"],
};

export const productSchema = (product, canonicalUrl) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: product.title,
  description: product.description,
  brand: { "@type": "Brand", name: "O Law Ventures Ltd" },
  offers: {
    "@type": "Offer",
    price: Number(product.price).toFixed(2),
    priceCurrency: (product.currency || "gbp").toUpperCase(),
    availability: product.available
      ? "https://schema.org/InStock"
      : "https://schema.org/PreOrder",
    url: canonicalUrl,
  },
});
